import { render, staticRenderFns } from "./manage-antecedent.html?vue&type=template&id=56d208f9&scoped=true&external"
import script from "./manage-antecedent.js?vue&type=script&lang=js&external"
export * from "./manage-antecedent.js?vue&type=script&lang=js&external"
import style0 from "./manage-antecedent.scss?vue&type=style&index=0&id=56d208f9&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d208f9",
  null
  
)

export default component.exports